import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import classNames from 'classnames';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var RememberedAccountsLayout = function RememberedAccountsLayout(_ref) {
  var title = _ref.title,
    content = _ref.content,
    controls = _ref.controls;
  var deviceType = useDeviceType();
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [/*#__PURE__*/_jsx("div", {
      className: classNames(styles['title'], styles["title--".concat(deviceType)]),
      children: title
    }), /*#__PURE__*/_jsxs("div", {
      className: classNames(styles['content'], styles["content--".concat(deviceType)]),
      children: [content, /*#__PURE__*/_jsx("div", {
        className: classNames(styles['controls'], styles["controls--".concat(deviceType)]),
        children: controls
      })]
    })]
  });
};